import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {offerUrlBuilder} from "../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital, getPropertiesCountFieldName} from "../helpers/OfferType";
import {OfferType} from "../types/OfferType";
import {offerPlural} from "../utils/offer_plural";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

export interface IProps {
    recommendedRegions: IRecommendedRegion[];
    offerType: OfferType | null;
    country?: number | null;
}

export interface IRecommendedRegion {
    id: number;
    name: string;
    slug: string;
    stats: {
        properties_all_count_for_sale: number;
        properties_flats_count_for_sale: number;
        properties_houses_count_for_sale: number;
        properties_commercials_count_for_sale: number;
    } | null;
}

export const OfferLocationLinksMixed = React.memo(({recommendedRegions, offerType, country}: IProps) => {
    return (
        <>
            {recommendedRegions.map((region) => {
                const amount = region.stats ? region.stats[getPropertiesCountFieldName(offerType)] : 0;
                const {friendlySlug, countrySlug} = offerUrlBuilder({type: offerType, region: region.slug, country: country});

                if (amount > 0) {
                    let link = rpAppLink.offer.listFriendly({friendlySlug: friendlySlug});
                    if (country === Country.SPAIN) {
                        link = rpAppLink.offer.listFriendlyAbroad({
                            friendlySlug: friendlySlug,
                            country: countrySlug,
                            abroadRegionSlug: region.slug
                        });
                    }
                    const linkText = `${offerType ? `${getOfferTypeNamePluralCapital(offerType)}` : null} ${region.name} (${amount} ${offerPlural(amount)})`;

                    return <OfferLocationLinksItem disableSelfLinking linkText={linkText} url={link} key={region.id} />;
                }
            })}
        </>
    );
});
import React from "react";

import {rpAppLink} from "@pg-mono/rp-routes";

import {Country} from "../../region/types/Country";
import {offerUrlBuilder} from "../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital, getPropertiesCountFieldName} from "../helpers/OfferType";
import {OfferType} from "../types/OfferType";
import {offerPlural} from "../utils/offer_plural";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

export interface IProps {
    recommendedRegions: IRecommendedRegion[];
    offerType: OfferType | null;
    country?: number | null;
}

export interface IRecommendedRegion {
    id: number;
    name: string;
    slug: string;
    stats: {
        properties_all_count_for_sale: number;
        properties_flats_count_for_sale: number;
        properties_houses_count_for_sale: number;
        properties_commercials_count_for_sale: number;
    } | null;
}

export const OfferLocationLinksMixed = React.memo(({recommendedRegions, offerType, country}: IProps) => {
    return (
        <>
            {recommendedRegions.map((region) => {
                const amount = region.stats ? region.stats[getPropertiesCountFieldName(offerType)] : 0;
                const {friendlySlug, countrySlug} = offerUrlBuilder({type: offerType, region: region.slug, country: country});

                if (amount > 0) {
                    let link = rpAppLink.offer.listFriendly({friendlySlug: friendlySlug});
                    if (country === Country.SPAIN) {
                        link = rpAppLink.offer.listFriendlyAbroad({
                            friendlySlug: friendlySlug,
                            country: countrySlug,
                            abroadRegionSlug: region.slug
                        });
                    }
                    const linkText = `${offerType ? `${getOfferTypeNamePluralCapital(offerType)}` : null} ${region.name} (${amount} ${offerPlural(amount)})`;

                    return <OfferLocationLinksItem disableSelfLinking linkText={linkText} url={link} key={region.id} />;
                }
            })}
        </>
    );
});
